import {
  AnyAction,
  createListenerMiddleware,
  isRejected,
} from "@reduxjs/toolkit";
import { notifyLoadError } from "Components/Notify/notify";

// Load thunks that already show their own error toast.
const REPORTS_OWN_ERROR = new Set([
  "expense/getExpenseDetail",
  "vehicles/getVehicle",
  "vehicles/getVehicleLatestOdometer",
  "announcements/getAnnouncementsList",
  "samsara/getSamsaraVehicleGeoPosition",
  "ai/getDataFromInvoice",
]);

// Not connection problems, so "check your connection" would mislead:
// 401 signs the user out (axios interceptor), 403 is a section the role
// can't see, and 404 is how some endpoints say "none yet".
const NOT_A_LOAD_FAILURE = /status code (401|403|404)\b/;

/**
 * A failed `…/getX` thunk. Thunks swallowed errors or only reset
 * `loading`, so a 500 used to look like an empty list. Skips cancelled
 * requests and the statuses above; pages show those in their own state.
 */
export const isFailedLoad = (action: AnyAction) => {
  if (!isRejected(action) || action.meta.aborted || action.meta.condition) {
    return false;
  }
  const thunk = action.type.replace(/\/rejected$/, "");
  if (!/\/get[A-Z]/.test(thunk) || REPORTS_OWN_ERROR.has(thunk)) return false;
  const { name, message = "" } = action.error;
  return name !== "CanceledError" && !NOT_A_LOAD_FAILURE.test(message);
};

const loadErrorListener = createListenerMiddleware();

loadErrorListener.startListening({
  predicate: isFailedLoad,
  effect: () => notifyLoadError(),
});

export default loadErrorListener;
